const UPDATE_LOT_INFO = {
  INVALID_MATERIAL_TYPE_EMPTY: 'Material type cannot be empty.',
  INVALID_STILLWTER_SHIPMENT_ID_EMPTY: 'Stillwater shipment ID cannot be empty.',
  INVALID_STILLWTER_SHIPMENT_ID_INVALID: 'Stillwater shipment ID must have a valid format.',
  INVALID_STILLWTER_SHIPMENT_ID_LENGTH:
    'Stillwater shipment ID cannot be longer than 15 characters.',
};

export { UPDATE_LOT_INFO };
